import { render, staticRenderFns } from "./RightsHolderMandateMetadata.vue?vue&type=template&id=6e955214&scoped=true&"
import script from "./RightsHolderMandateMetadata.vue?vue&type=script&lang=js&"
export * from "./RightsHolderMandateMetadata.vue?vue&type=script&lang=js&"
import style0 from "./RightsHolderMandateMetadata.vue?vue&type=style&index=0&id=6e955214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e955214",
  null
  
)

export default component.exports